import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { black, grey } from "designSystem/styles/color";
import { FlexColumn, FlexRowCenter, IconButton, Text, TextField } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { ProofingStageAccordion } from "./ProofingStageAccordion";
import { ProofingStageNumberChip } from "./ProofingStageNumberChip";
import { ProofingStageReviewers } from "./ProofingStageReviewers";
import { useProofingStore } from "./ProofingStore";

export const GreyLabelText = styled(Text)(() => ({
	color: black[500],
}));

export interface ProofingStageProps {
	isEditOperation?: boolean;
	stageIndex: number;
}

const ProofingStage: FunctionComponent<ProofingStageProps> = observer((props) => {
	const store = useProofingStore();
	const {
		hasOneStage,
		stages,
	} = store;
	const { stageIndex } = props;
	const stage = stages[stageIndex - 1];
	const {
		disableRemoveStageButton,
		hasStageNameError,
		isStageLockedAndStarted,
		stageNameError,
		stageNameOrBlank,
	} = stage;
	


	function removeStage(): void {
		store.removeStage(stageIndex);
	}

	function setStageName(event: React.SyntheticEvent): void {
		stage.setStageName((event.target as HTMLInputElement).value);
	}

	return (
		<FlexColumn
			sx={{
				backgroundColor: grey[50],
				border: STANDARD_BORDER_STYLE,
				borderRadius: 1,
				marginTop: 6,
				height: "auto",
			}}
		>
			<FlexRowCenter
				justifyContent="space-between"
				mt={3}
				mx={3}
			>
				<FlexRowCenter gap={1}>
					<IconButton onClick={stage.setExpand}>
						<ChevronRightIcon
							sx={{
								transform: stage.expand ? "rotate(90deg)" : "",
								transition: "transform 0.2s linear",
							}}
						/>
					</IconButton>
					<ProofingStageNumberChip stageIndex={stageIndex} />
					<TextField
						disabled={isStageLockedAndStarted}
						error={hasStageNameError}
						helperTextRes={stageNameError}
						onChange={setStageName}
						placeholderRes="StageName"
						sx={{
							marginRight: 4,
							width: 200,
						}}
						value={stageNameOrBlank}
					/>
				</FlexRowCenter>
				<FlexRowCenter>
					<IconButton
						design="outline"
						disabled={disableRemoveStageButton}
						onClick={removeStage}
						res={hasOneStage ? "ProofsMustHaveStage" : null}
						showTooltipWhenDisabled
						size="large"
					>
						<CloseIcon />
					</IconButton>
				</FlexRowCenter>
			</FlexRowCenter>
			<ProofingStageAccordion {...props} />
			<ProofingStageReviewers stage={stage} />
		</FlexColumn>
	);
});
export default ProofingStage;